import type { JSX } from 'react'

export const HeartSolidIcon = (): JSX.Element => (
  <use href='#heartSolidIcon' height='100%' width='100%' />
)
